import type { ShoppingCreate } from "@sytofood/shared";

type PantryUnit = NonNullable<ShoppingCreate["unit"]>;

const PANTRY_UNITS: ReadonlySet<PantryUnit> = new Set([
  "g",
  "kg",
  "ml",
  "l",
  "szt",
  "opak",
  "łyż",
  "szkl",
]);

const MAP: Record<string, PantryUnit | null> = {
  kromka: "szt",
  kromki: "szt",
  kromek: "szt",
  plaster: "szt",
  plastry: "szt",
  plasterki: "szt",
  plasterek: "szt",
  ząbek: "szt",
  ząbki: "szt",
  ząbków: "szt",
  zabek: "szt",
  zabki: "szt",
  sztuk: "szt",
  sztuka: "szt",
  sztuki: "szt",
  opakowanie: "opak",
  opakowania: "opak",
  paczka: "opak",
  paczki: "opak",
  łyżka: "łyż",
  łyżki: "łyż",
  łyżek: "łyż",
  łyżeczka: "łyż",
  łyżeczki: "łyż",
  lyzka: "łyż",
  lyzki: "łyż",
  lyzeczka: "łyż",
  szklanka: "szkl",
  szklanki: "szkl",
  szklanek: "szkl",
  garść: "szt",
  garści: "szt",
  garsc: "szt",
  szczypta: null,
  szczypty: null,
  odrobina: null,
};

// Maps free-form Polish unit from LLM to our pantry/shopping enum or null.
export function normalizeToPantryUnit(raw: string | null): PantryUnit | null {
  if (!raw) return null;
  const key = raw.trim().toLowerCase();
  if (PANTRY_UNITS.has(key as PantryUnit)) return key as PantryUnit;
  if (key in MAP) return MAP[key] ?? null;
  return null;
}
